import { logger as E } from "../../shared-lib/index.js";
import r from "../managers/braze-instance.js";
import ue from "../models/braze-event.js";
import H from "../models/request-result.js";
var c = {
  rt: function rt(e, o, t) {
    var n, s;
    var i = new H(),
      l = r.u();
    if (!l) return E.info("Not logging event with type \"".concat(e, "\" because the current session ID could not be found.")), i;
    var d = l.qo();
    return i.ue.push(new ue(t || (null === (n = r.ir()) || void 0 === n ? void 0 : n.getUserId()), e, new Date().valueOf(), d, o)), i.W = (null === (s = r.p()) || void 0 === s ? void 0 : s.Eo(i.ue)) || !1, i;
  }
};
export default c;